import React from 'react';
import ReactDOM from 'react-dom/client';
import { UserProvider } from './utils/userContext';
import App from './App';
import 'antd/dist/reset.css'; 
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
  </React.StrictMode>
);